import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "text-h6 text--text mb-2" }, [
        _vm._v("\n    Что даёт клуб\n  "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "text-body-1 text--text" }, [
        _vm._v(
          "\n    Возможность получить скидку 30% на консультацию у врача по клубному купону.\n  "
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "text-h6 text--text mt-8 mb-2" }, [
        _vm._v("\n    Как получить купон и скидку\n  "),
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "text-h6 text--text mt-8 mb-2" }, [
        _vm._v("\n    Как вступить в клуб\n  "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "text-body-1 text--text mb-4" }, [
        _vm._v(
          "\n    Просто воспользуйтесь клубной ценой и вы станете участником клуба на 6 месяцев.\n    После доступ к клубным ценам на 6 месяцев будет стоить 99 ₽.\n  "
        ),
      ]),
      _vm._v(" "),
      _c(VDivider, { staticClass: "my-8" }),
      _vm._v(" "),
      _c("div", { staticClass: "text-h6 text--text mb-4" }, [
        _vm._v("\n    Вопросы и ответы\n  "),
      ]),
      _vm._v(" "),
      _c(
        VExpansionPanels,
        { attrs: { multiple: "" } },
        _vm._l(_vm.expansionPanel, function (item, index) {
          return _c(
            VExpansionPanel,
            { key: `${_vm.componentName}ExpansionItem${index}` },
            [
              _c(
                VExpansionPanelHeader,
                {
                  staticClass: "text-left justify-space-between",
                  attrs: { "expand-icon": _vm.vuetifyIcons.arrowDown },
                },
                [
                  _c("span", { staticClass: "text-body-1" }, [
                    _vm._v(_vm._s(item.title)),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(VExpansionPanelContent, { staticClass: "text-body-1" }, [
                _vm._v("\n        " + _vm._s(item.description) + "\n      "),
              ]),
            ],
            1
          )
        }),
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "mt-10 mb-4" }, [
        _c("div", { staticClass: "text-body-2 text-secondary--text" }, [
          _vm._v(
            "\n      © 2011 — " + _vm._s(_vm.nowYear) + ", ООО «МЕДРОКЕТ»\n    "
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-block text-body-2 text-secondary--text mt-2" },
          [
            _vm._v("\n      Оплачивая, вы соглашаетесь\n      с "),
            _c(
              "a",
              {
                staticClass: "text-secondary--text",
                attrs: {
                  href: _vm.pdfData.coupon,
                  rel: "noopener noreferrer",
                  target: "_blank",
                },
              },
              [_vm._v("офертой")]
            ),
            _vm._v("\n      и "),
            _c(
              "a",
              {
                staticClass: "text-secondary--text",
                attrs: {
                  href: _vm.pdfData.participation,
                  rel: "noopener noreferrer",
                  target: "_blank",
                },
              },
              [_vm._v("правилами клуба")]
            ),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "b-club-list text-body-1 text--text" }, [
      _c("div", { staticClass: "b-club-list__item" }, [
        _vm._v(
          "\n      Оплатите на сайте ПроДокторов 50% стоимости консультации по клубной цене\n    "
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "b-club-list__item" }, [
        _vm._v("\n      Получите клубный купон на скидку\n    "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "b-club-list__item" }, [
        _vm._v(
          "\n      В день визита оплачиваете в клинике оставшиеся 50%\n    "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }